import { useQuery } from "@tanstack/react-query";

import { CardGrid } from "@bagel-web/components";
import { CommonAPI } from "../types";
import { apiRequestQueries } from "../queries";
import APIRequestCards from "../apiRequest/APIRequestCards";
import { Alert, Spinner } from "react-bootstrap";
import APIRequestHeaderCard from "../apiRequest/APIRequestHeaderCard";
import { useEffect } from "react";

const AgentMomentAPIRequest = ({
  organization,
  commonAPI,
  requestId,
  setRequestHasError,
  setRequestIsLoading,
}: {
  organization: string;
  commonAPI: CommonAPI;
  requestId?: string | null;
  setRequestHasError: (error: boolean) => void;
  setRequestIsLoading: (error: boolean) => void;
}) => {
  const {
    data: apiRequest,
    isPending,
    isError,
  } = useQuery({
    queryKey: apiRequestQueries.get({
      requestId: requestId ?? "",
      organization,
    }),
    queryFn: () =>
      requestId ? commonAPI.fetchAPIRequest({ requestId, organization }) : null,
    staleTime: Infinity,
  });

  useEffect(() => {
    const { res_status_code } = apiRequest || {};
    setRequestHasError(
      !!res_status_code && (res_status_code < 200 || res_status_code >= 300)
    );
  }, [isPending, apiRequest]);

  useEffect(() => {
    setRequestIsLoading(!requestId || isPending);
  }, [requestId, isPending]);

  return (
    <div>
      {isPending && <Spinner />}
      {isError && <Alert variant="warning">Error loading API request</Alert>}
      {apiRequest && (
        <CardGrid unitWidth={800} maxColumns={2}>
          <APIRequestHeaderCard apiRequest={apiRequest} />
          <APIRequestCards apiRequest={apiRequest} />
        </CardGrid>
      )}
    </div>
  );
};
export default AgentMomentAPIRequest;
